import General from 'module/general/General'
import DepartmentConfiguration from 'module/department-configuration/DepartmentConfiguration'
import AdminAccessibility from 'module/admin-accessbility/AdminAccessibility'
import ApprovalRouting from 'module/approval-routing/ApprovalRouting'
import AdminLeaveSetting from 'module/leave/pages/adminLeaveSetting/view'
import AdminClaimSetting from 'module/claim/pages/admin/view/AdminClaimSetting'
import PayrollConfiguration from 'module/payroll/pages/payroll-configuration/view/PayrollConfiguration'
import AppraisalCompanyMgmt from 'module/performance/pages/appraisal-company-mgmt/view/AppraisalCompanyMgmt'
import AttendanceSettings from 'module/time-attendance/view/settings/AttendanceSettings'

const allCompanyTabs = [
  {
    name: 'general',
    label: 'General',
    link: 'general',
    permissionId: 1,
    component: <General />,
  },
  {
    name: 'adminPermissions',
    label: 'Admin Permissions',
    link: 'admin-permissions',
    permissionId: 13,
    component: <AdminAccessibility />,
  },
  {
    name: 'departmentConfiguration',
    label: 'Department Configuration',
    link: 'department-configuration',
    permissionId: 14,
    component: <DepartmentConfiguration />,
  },

  {
    name: 'approvalRouting',
    label: 'Approval Chain',
    link: 'approval-chains',
    permissionId: 15,
    component: <ApprovalRouting />,
  },
  {
    name: 'leave',
    label: 'Leave',
    link: 'leave',
    permissionId: 2,
    component: <AdminLeaveSetting />,
  },
  {
    name: 'claim',
    label: 'Claim',
    link: 'claim',
    permissionId: 3,
    component: <AdminClaimSetting />,
  },
  {
    name: 'payroll',
    label: 'Payroll',
    link: 'payroll',
    permissionId: 4,
    component: <PayrollConfiguration />,
  },
  {
    name: 'appraisal',
    label: 'Appraisal',
    link: 'appraisal',
    permissionId: 10,
    component: <AppraisalCompanyMgmt />,
  },
  {
    name: 'attendance',
    label: 'Attendance',
    link: 'time-attendance',
    permissionId: 19,
    component: <AttendanceSettings />,
  },
]

export default allCompanyTabs
